const API = process.env.REACT_APP_API_URL;

const headers = (token) => ({
  "Content-Type": "application/json",
  Authorization: `Bearer ${token}`,
});

// =========================================================
// CURRENT COMPETITION SURVEY
// =========================================================

export const GetCurrentCompetitionSurvey = async (token) => {
  try {
    const response = await fetch(`${API}/CompetitionSurvey/GetCurrentSurvey`, {
      method: "GET",
      headers: headers(token),
      credentials: "include",
    });

    const text = await response.text();

    let data;

    try {
      data = text ? JSON.parse(text) : null;
    } catch {
      throw new Error("Invalid server response.");
    }

    if (!response.ok) {
      throw new Error(
        data?.message || "Unable to retrieve the current competition survey.",
      );
    }

    return data;
  } catch (error) {
    console.error("GetCurrentCompetitionSurvey error:", error);
    throw error;
  }
};
